export default __webpack_public_path__ + "static/disk-deck-150-3ac6a0363b403b452704a0c16b19daf6.png";